var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 73,
    viewBox: "0 0 63 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_4807)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_25_4807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2805 3L60.5611 19.9254V53.7762L31.2805 70.7015L2 53.7762V19.9254L31.2805 3Z",
    fill: "#0E1D2D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.7512 2.18576L31.2805 1.9137L30.8099 2.18576L1.52934 19.1111L1.05952 19.3827V19.9254V53.7762V54.3188L1.52934 54.5904L30.8099 71.5158L31.2805 71.7878L31.7512 71.5158L61.0317 54.5904L61.5016 54.3188V53.7762V19.9254V19.3827L61.0317 19.1111L31.7512 2.18576Z",
    stroke: "#ED4032",
    strokeWidth: 1.88096
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_25_4807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7512 2.18576L31.2805 1.9137L30.8099 2.18576L1.52934 19.1111L1.05952 19.3827V19.9254V53.7762V54.3188L1.52934 54.5904L30.8099 71.5158L31.2805 71.7878L31.7512 71.5158L61.0317 54.5904L61.5016 54.3188V53.7762V19.9254V19.3827L61.0317 19.1111L31.7512 2.18576Z",
    stroke: "#ED4032",
    strokeWidth: 1.88096
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_25_4807",
    x: 0.119141,
    y: 0.827393,
    width: 62.323,
    height: 75.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.76192
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.64289
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25_4807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_25_4807",
    x: -3.64278,
    y: -2.93453,
    width: 69.8468,
    height: 79.5705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88096,
    result: "effect1_foregroundBlur_25_4807"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_4807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexWrong);
export default __webpack_public_path__ + "static/media/hexWrong.a177ebf4cbc5879cc6baa0a3cf0aebd6.svg";
export { ForwardRef as ReactComponent };